import { useState, useEffect } from "react";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

import {
  ConfigProvider,
  Space,
  Table,
  Tag,
  Input,
  Flex,
  InputNumber,
  Button,
  Alert,
  message,
  DatePicker,
} from "antd";
const { RangePicker } = DatePicker;

import { API, URL } from "@/config/api";

import dayjs from "dayjs";

import { ICONS } from "@/assets";
import CustomModal from "@/components/CustomModal";
const { TextArea } = Input;

import { ColumnReportJurnal } from "../../../library/FormColumn";

import jsPDF from "jspdf";
import "jspdf-autotable";

import { createStyles } from "antd-style";
const useStyle = createStyles(({ css, token }) => {
  const { antCls } = token;
  return {
    customTable: css`
      ${antCls}-table {
        ${antCls}-table-container {
          ${antCls}-table-body,
          ${antCls}-table-content {
            scrollbar-width: thin;
            scrollbar-color: #eaeaea transparent;
            scrollbar-gutter: stable;
          }
        }
      }
    `,
  };
});

const ReportJurnalPage = () => {
  const { styles } = useStyle();
  const [data, setData] = useState([]);
  const [dateString, setDateString] = useState(["", ""]);
  const [loading, setLoading] = useState(false);

  // console.log("selectedData", data);

  const extendedColumn = [...ColumnReportJurnal.columns];

  const [messageApi, contextHolder] = message.useMessage();

  const onChange = (date, dateString) => {
    setDateString(dateString);
  };

  // console.log(dateString);

  const getData = async () => {
    try {
      setLoading(true);
      const response = await API.get(
        URL.TRX_INHOUSE + `?start=${dateString[0]}&end=${dateString[1]}`
      );
      setData(response?.data?.data);
      setLoading(false);
    } catch (error) {
      console.error(error);
      message.error("Data failed to fetch!");
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();

    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, [dateString]);

  const exportToExcel = async () => {
    const date = dayjs(); // Get current date
    const getMonthName = date.format("MMM");
    const formattedDate = date.format("MMM-YY");

    const filteredMonth = [
      ...new Set(
        data.map((item) => {
          const date = new Date(item.tgl);
          return `${date.getFullYear()}-${date.getMonth()}`; // Simpan sebagai "YYYY-MM"
        })
      ),
    ]
      .map((item) => {
        const [year, monthIndex] = item.split("-").map(Number); // Pisahkan "YYYY-MM"

        return {
          year,
          nummberMonth: item,
          month: new Date(year, monthIndex).toLocaleString("en-US", {
            month: "short",
          }), // Konversi ke format singkat
        };
      })
      .sort((a, b) => a.month - b.month || a.month - b.month)
      .map(({ year, month, nummberMonth }) => ({ year, month, nummberMonth }));

    const workbook = new ExcelJS.Workbook();

    // let worksheet;

    filteredMonth.forEach((sheetInfo) => {
      const filteredData = data.filter((e) => {
        const date = new Date(e.tgl);
        const monthName = date.toLocaleString("en-US", { month: "short" }); // Konversi bulan ke format "Feb"
        const year = date.getFullYear(); // Ambil tahun

        return monthName === sheetInfo.month && year === sheetInfo.year;
      });

      const worksheet = workbook.addWorksheet(sheetInfo.month);

      // Tambahkan header utama
      worksheet.mergeCells("A1:F1");
      const header1 = worksheet.getCell("A1");
      header1.value = "JURNAL";
      header1.font = { bold: true, size: 24 };
      header1.alignment = { horizontal: "center", vertical: "middle" };
      header1.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFBDD7EE" }, // Light blue background
      };
      header1.border = {
        top: { style: "medium" },
        left: { style: "medium" },
        bottom: { style: "medium" },
        right: { style: "medium" },
      };

      worksheet.mergeCells("A2:H2");
      const header3 = worksheet.getCell("A2");
      header3.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "ffffff" }, // white background
      };

      // Tambahkan sub-header dengan tanggal
      worksheet.mergeCells("A3:F3");
      const header2 = worksheet.getCell("A3");
      header2.value = sheetInfo.month + "-" + sheetInfo.year;
      header2.font = { bold: true, size: 32 };
      header2.alignment = { horizontal: "center", vertical: "middle" };
      header2.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFBDD7EE" }, // Light blue background
      };
      header2.border = {
        top: { style: "medium" },
        left: { style: "medium" },
        bottom: { style: "medium" },
        right: { style: "medium" },
      };

      worksheet.getRow(4).height = 25;

      // Tambahkan header kolom
      const headers = [
        "TANGGAL",
        "NOMOR AKUN",
        "NAMA AKUN",
        "KETERANGAN",
        "DEBIT",
        "KREDIT",
      ];
      headers.forEach((header, index) => {
        const cell = worksheet.getCell(4, index + 1); // Baris ke-3 untuk header kolom
        cell.value = header;
        cell.font = { bold: false, size: 12 };
        cell.alignment = { horizontal: "center", vertical: "middle" };
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFBDD7EE" }, // Light blue background
        };
        cell.border = {
          top: { style: "medium" },
          left: { style: "medium" },
          bottom: { style: "medium" },
          right: { style: "medium" },
        };
      });

      filteredData.forEach((item, rowIndex) => {
        const row = worksheet.getRow(5 + rowIndex); // Data dimulai dari baris ke-4
        row.getCell(1).value = item.tgl;
        row.getCell(2).value = item.noAcc;
        row.getCell(3).value = item.nameAcc;
        row.getCell(4).value = item.keterangan;
        row.getCell(5).value = item.kategori == "debit" ? item.amount : null;
        row.getCell(6).value = item.kategori == "kredit" ? item.amount : null;

        row.getCell(1).alignment = { horizontal: "center", vertical: "middle" };
        row.getCell(2).alignment = { horizontal: "center", vertical: "middle" };

        // Format untuk nilai angka (Debet, Kredit, Saldo)
        row.getCell(5).numFmt = "Rp #,##0.00;[Red]-Rp #,##0.00";
        row.getCell(6).numFmt = "Rp #,##0.00;[Red]-Rp #,##0.00";

        const borderStyle = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };

        // Loop through cells 1 to 5 and apply the border style
        for (let i = 1; i <= headers.length; i++) {
          row.getCell(i).border = borderStyle;
        }
      });

      // ================= get total data ======================= //
      let totalDebit = 0;
      let totalKredit = 0;

      filteredData.forEach((item) => {
        if (item.kategori === "debit") {
          totalDebit += item.amount;
        } else if (item.kategori === "kredit") {
          totalKredit += item.amount;
        }
      });

      // Menentukan baris terakhir setelah data
      const lastRowIndex = 5 + filteredData.length + 2; // Baris di bawah data terakhir
      const totalRow = worksheet.getRow(lastRowIndex);

      // Menetapkan label "Total" pada kolom pertama
      totalRow.getCell(4).value = "TOTAL";
      totalRow.getCell(4).font = { bold: true };
      totalRow.getCell(4).alignment = { horizontal: "center" };
      totalRow.getCell(5).font = { bold: true };
      totalRow.getCell(6).font = { bold: true };

      // Menetapkan total debit dan kredit
      totalRow.getCell(5).value = totalDebit;
      totalRow.getCell(6).value = totalKredit;

      // Format angka seperti pada data utama
      totalRow.getCell(5).numFmt = "Rp #,##0.00;[Red]-Rp #,##0.00";
      totalRow.getCell(6).numFmt = "Rp #,##0.00;[Red]-Rp #,##0.00";

      // Membuat border agar rapi
      const borderStyle = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" }, // Menggunakan border double untuk total
        right: { style: "thin" },
      };

      totalRow.getCell(4).border = borderStyle;
      totalRow.getCell(5).border = borderStyle;
      totalRow.getCell(6).border = borderStyle;

      // Atur lebar kolom
      worksheet.columns = [
        { width: 15 },
        { width: 15 },
        { width: 25 },
        { width: 60 },
        { width: 20 },
        { width: 20 },
      ];
    });

    // Generate file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, `Laporan Jurnal Bulan ${formattedDate}.xlsx`);
  };

  return (
    <div>
      {contextHolder}

      <h1 className="text-4xl font-semibold mb-8 text-center">Report Jurnal</h1>

      <div className="flex justify-between items-center mb-4 flex-wrap gap-4">
        <div className="flex gap-4 items-center">
          <h1 className="font-semibold">Filter : </h1>
          <RangePicker size="middle" onChange={onChange} />
        </div>

        <div className="">
          {/* <Button
            size="large"
            // type="primary"
            onClick={exportPDF}
            className=" bg-red-500 text-white py-2 px-4 rounded-md mb-4"
          >
            Export PDF
          </Button> */}

          <Button
            size="large"
            // type="primary"
            onClick={exportToExcel}
            className="bg-green-600 text-white py-2 px-4 rounded-md"
          >
            Export Excel
          </Button>
        </div>
      </div>

      <ConfigProvider
        theme={{
          components: {
            Table: {
              colorPrimary: "#0164A2",
              headerColor: "#fff",
              headerBg: "#0164A2",
              headerBorderRadius: 6,
              algorithm: true,
              // borderColor: "#000",
            },
            Pagination: {
              colorPrimary: "#0164A2",
              colorPrimaryHover: "#0164A2",
              colorPrimaryBorder: "#0164A2",
              algorithm: true,
            },
          },
        }}
      >
        <Table
          className={styles.customTable}
          columns={extendedColumn}
          dataSource={data}
          size="middle"
          scroll={{
            x: "max-content",
            // y: 55 * 5,
          }}
        />
      </ConfigProvider>
    </div>
  );
};

export default ReportJurnalPage;
